<div class="content-block">
    <div class="dx-card responsive-paddings">

        <div style="padding-left: 25px">
            <h2 class="content-block">Card disbursements</h2>

            <!-- <dx-data-grid class="dx-card wide-card" [dataSource]="dataSource" [showBorders]="false" [focusedRowEnabled]="true"
                [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true">
                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxi-column dataField="Id" [width]="90"> </dxi-column>
                <dxi-column dataField="BatchName" [width]="190" caption="Batch Name"> </dxi-column>
                <dxi-column dataField="BatchType" [width]="190" caption="Batch Type"> </dxi-column>
                <dxi-column dataField="NumberOfRecords" [width]="190" caption="Number Of Records"> </dxi-column>
                <dxi-column dataField="Created" [width]="190" caption="Created"> </dxi-column>
            </dx-data-grid> -->
        </div>

    </div>
</div>